/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

import {Pipe, PipeTransform} from '@angular/core';

import {Json} from '../facade/lang';
export class JsonPipe implements PipeTransform {
  transform(value: any): string { return Json.stringify(value); }
/** @nocollapse */
static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{name: 'json', pure: false}, ] },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
